import { useState } from 'react';
import useAppSelector from 'hooks/useAppSelector';
import useAppDispatch from 'hooks/useAppDispatch';
import { getUserAction } from 'store/modules/auth/actions';
import { getCookieSessionToken } from 'utils/session';
import { CandidateService } from 'services/user.service';
import _ from 'lodash';
import Page from 'components/templates/Page';
import { Typography, Divider, Box, Button, Checkbox } from '@mui/material';
import { useStyles } from './styles';

function Terms() {
  const styles = useStyles();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);

  const [checked, setChecked] = useState(false);

  const termsVersion = process.env.REACT_APP_TERMS_VERSION ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const sendTermsVersion = () => {
    if (user) {
      CandidateService.acceptTerms(termsVersion).then(() => {
        const updatedUser = _.cloneDeep(user);
        updatedUser.policyVersion = termsVersion;

        const token = getCookieSessionToken();
        if (token) {
          dispatch(getUserAction(token));
        }
      });
    }
  };

  return (
    <Page title="Atualização nos termos de uso" maxWidth={796}>
      <Typography className={styles.subtitle}>
        Termos e condições gerais de uso e política de segurança e privacidade
        do website
      </Typography>
      <Typography className={styles.lastUpdate}>
        Última atualização: 12 de janeiro de 2022
      </Typography>
      <Divider />
      <Typography className={styles.subtitle}>Termos de uso:</Typography>
      <Typography>
        O presente Termos e Condições Gerais de Uso e Política de Privacidade
        (“Termos”), aplica-se aos usuários (“Usuários”) que utilizam o site
        https://www.gria.io (“Website”) e os serviços disponibilizados pela
        <b> Gria Software e Serviços S/A </b>, pessoa jurídica de direito
        privado, inscrita no CNPJ/ME sob o nº 40.545.334/0001-65, com sede na
        Alameda Rio Negro, nº 503, Sala 2020, Bairro Alphaville, na cidade de
        Barueri, estado de São Paulo, CEP 06454-000, doravante denominada “Gria”
        no Website. Este Website é um serviço online de inteligência em Recursos
        Humanos, voltado aos Usuários.
      </Typography>
      <Typography className={styles.subtitle}>Dos usuários:</Typography>
      <Typography>
        É considerado Usuário toda pessoa física ou jurídica que acesse o
        Website com o intuito de se cadastrar na plataforma, seja como candidato
        ou como empresa.
      </Typography>
      <Typography className={styles.subtitle}>Do objeto dos termos:</Typography>
      <Typography>
        Estabelecer as condições em que os serviços de inteligência em Recursos
        Humanos oferecidos pela “Gria” serão divulgados e disponibilizados aos
        Usuários deste Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Da oferta dos serviços:
      </Typography>
      <Typography>
        Por intermédio deste Website, a “Gria” fornece aos Usuários a
        facilitação de serviços de inteligência em Recursos Humanos. Os serviços
        poderão ser utilizados por empresas que estejam contratando e realizando
        processos seletivos (“Empresa Recrutadora/Empresas Recrutadoras”) ou por
        profissionais que estejam à procura de vagas de emprego
        (“Candidato/Candidatos”). Nos casos de Candidatos, os serviços prestados
        pela Gria, voltam-se à seleção de oportunidades profissionais, ou seja,
        localização de vagas de empregos cadastradas na plataforma, compatíveis
        ao perfil profissional do Candidato. O Candidato terá acesso às vagas de
        emprego disponibilizadas pelas Empresas Recrutadoras e poderá se
        candidatar para a mesma, bem como poderá ser localizado por uma Empresa
        Recrutadora interessada em seu perfil profissional. Nos casos das
        Empresas Recrutadoras, os serviços prestados pela “Gria” baseiam-se na
        disponibilização da plataforma para a empresa realizar o recrutamento de
        mão de obra qualificada à vaga cadastrada e ofertada pela mesma. A
        Empresa Recrutadora irá cadastrar vagas de emprego na plataforma,
        fornecendo as informações que entender como úteis sobre a vaga, bem como
        os requisitos esperados pelo Candidato para participar da seleção.
        Ainda, poderá a Empresa Recrutadora localizar e contatar, pela
        plataforma, Candidatos que acredite ter o perfil adequado para a vaga
        disponibilizada.
      </Typography>
      <Typography className={styles.subtitle}>
        Da comunicação com os usuários:
      </Typography>
      <Typography>
        O tratamento de dados pessoais pela GRIA poderá ter diversas
        finalidades, tais como: O e-mail será utilizado como canal de
        comunicação para divulgar as oportunidades disponíveis, no caso do
        Candidato, ou para divulgar os candidatos compatíveis e que se
        candidataram às vagas cadastradas, no caso da Empresa Recrutadora. O
        e-mail será utilizado como canal de comunicação para, também, realizar o
        retorno do pedido de contato feito pelo Usuário, por meio da área “Fale
        Conosco” disponível no Website.
      </Typography>
      <Typography className={styles.subtitle}>Do contato:</Typography>
      <Typography>
        Este Website possui o canal denominado “Fale Conosco”, a ser utilizado
        como meio de comunicação entre a “Gria” e os Usuários deste Website que
        solicitarem contato. Os Usuários, ao utilizarem o canal, deverão
        preencher as seguintes informações: nome completo, e-mail, “sou” e
        escrever sua mensagem. No campo “sou”, os Usuários deverão indicar se
        são Candidatos ou Empresas Recrutadoras. Os Usuários poderão, ainda,
        utilizar-se do Webchat e do WhatsApp da “Gria” como meio de comunicação
        para solicitarem informações, tirarem dúvidas ou para solicitarem
        suporte técnico diretamente com profissionais da “Gria”. Os contatos
        realizados pelo Webchat e pelo WhatsApp serão respondidos em horário
        comercial, compreendido das 9h às 19h.
      </Typography>
      <Typography className={styles.subtitle}>
        Dos direitos e obrigações dos usuários:
      </Typography>
      <Typography>
        (a) Responsabilizar-se civil e criminalmente por todas as informações,
        inclusive cadastrais, que fornecerem à “Gria”; (b) Não utilizarem este
        Website ou qualquer material nele inserido para qualquer outro fim que
        não para os usos legais previstos nestes Termos; (c) Não inserirem neste
        Website qualquer conteúdo ilícito ou de qualquer modo contrário à moral
        e aos bons costumes ou que viole direitos de terceiros, como, por
        exemplo, mas não se limitando a, conteúdo pornográfico ou difamatório;
        (d) Não infringir qualquer norma ou lei; e (e) Não inserirem neste
        Website qualquer conteúdo que contenha vírus ou outros elementos físicos
        ou eletrônicos que possam causar danos ou impedir o normal funcionamento
        da rede, do sistema ou de equipamentos informáticos da “Gria” ou de
        terceiros, ou que provoque, por suas características (tais como forma,
        extensão etc.), dificuldades no normal funcionamento da plataforma. Os
        Usuários comprometem-se a utilizar este Website e seu conteúdo, ou seja,
        os textos, fotografias, gráficos, imagens, ícones, tecnologia, software,
        links e demais conteúdos audiovisuais ou sonoros, desenhos gráficos e
        códigos fonte disponibilizados na plataforma, em consonância ao
        ordenamento jurídico, à moral e os bons costumes geralmente aceitos, aos
        presentes Termos, à Política de Privacidade e demais instruções
        existentes neste Website. Os Usuários deverão abster-se de obter ou de
        tentar obter quaisquer conteúdos disponíveis neste Website por meios
        distintos daqueles que, em cada caso, tenham sido colocados à disposição
        para tais propósitos. Os Usuários responderão por qualquer fraude
        realizada por si ou por terceiros a ele vinculados, em meio virtual ou
        físico, de ações ou omissões culposas ou dolosas, ou ainda decorrentes
        da violação de quaisquer condições estabelecidas nestes Termos. Todas as
        informações fornecidas pelos Usuários devem ser precisas, verdadeiras e
        atualizadas. Em qualquer caso, os Usuários responderão, em âmbito cível
        e criminal, pela veracidade, exatidão e autenticidade dos dados
        informados. Os Usuários deverão fornecer um endereço de e-mail válido,
        através do qual a “Gria” realizará todos os contatos necessários. Todas
        as comunicações enviadas para o referido endereço serão consideradas
        lidas pelos Usuários, que se comprometem, assim, a consultar
        regularmente as mensagens recebidas e a respondê-las em prazo razoável.
      </Typography>
      <Typography className={styles.subtitle}>
        Dos direitos autorais:
      </Typography>
      <Typography>
        As marcas e os logotipos exibidos neste Website são de titularidade
        exclusiva da “Gria” e não podem ser utilizados em quaisquer lugares,
        incluindo outros websites, sem o prévio consentimento, por escrito,
        do(s) representante(s) legal(ais) da “Gria”. As marcas e os logos
        exibidos quando da disponibilização das oportunidades aos Candidatos são
        de titularidade exclusiva da Empresa Recrutadora da referida
        oportunidade e não podem ser utilizados em quaisquer lugares, incluindo
        outros websites, sem o prévio consentimento, por escrito, do(s)
        representante(s) legal(is) da Empresa Recrutadora.
      </Typography>
      <Typography className={styles.subtitle}>
        Do serviço de atendimento aos usuários:
      </Typography>
      <Typography>
        Os Usuários terão acesso ao Serviço de Atendimento ao Usuário (SAC) para
        sanar suas dúvidas, solucionar eventuais solicitações ou reclamações a
        respeito dos serviços de inteligência em Recursos Humanos
        disponibilizados pelo Website. O SAC poderá ser acionado por meio dos
        seguintes canais: (a) Através do e-mail suporte@gria.io; (b) Através de
        Webchat disponível no Website em horário comercial; e (c) Através de
        WhatsApp número (21) 99992-2724 em horário comercial.
      </Typography>
      <Typography className={styles.subtitle}>Da responsabilidade:</Typography>
      <Typography>
        A “Gria” não se responsabiliza por quaisquer danos, de qualquer
        natureza, que possam advir a terceiros em decorrência de conduta
        imprópria, ofensiva, contrária à legislação vigente ou de qualquer forma
        praticada pelos Usuários. Da mesma forma, a “Gria” não se responsabiliza
        por perdas e danos causados pela utilização irregular dos serviços por
        ela prestados, excluindo de sua responsabilidade, ainda, a ocorrência de
        efeitos de caso fortuito e força maior. A “Gria” tampouco se
        responsabiliza por quaisquer prejuízos, a qualquer título, que possam
        advir de decisões dos Usuários baseadas nas descrições das vagas ou do
        Candidato, a depender do caso, exibidos neste Website. Os Usuários
        declaram estar cientes que o acesso a este Website depende da
        funcionalidade simultânea de diversos fatores, alguns alheios ao
        controle da “Gria”, tais como a interação de servidores e serviços de
        telecomunicações de terceiros, a adequação dos equipamentos dos
        Usuários, entre outros. Assim, a “Gria” fica isenta de qualquer
        responsabilidade por falhas decorrentes de qualquer impossibilidade de
        acesso ao Website em virtude de motivos que fogem ao seu controle e
        diligência. A “Gria” não garante, sob nenhuma hipótese, que este Website
        esteja livre de possíveis falhas, interrupções, vírus, problemas ou
        outros fatores, não se responsabilizando, também, pela qualidade e
        segurança da rede utilizada pelos Usuários para acesso ao Website, uma
        vez que esta é mantida por terceiros e, portanto, foge do seu controle,
        diligência e responsabilidade. A “Gria” não será, em hipótese alguma,
        responsável por quaisquer danos decorrentes da interrupção do acesso
        deste Website sempre que tal indisponibilidade ocorrer por culpa de
        terceiros, o que foge ao seu controle e diligência. Os Usuários ficam
        cientes que a “Gria” recomenda para acesso ao Website a utilização de
        ferramentas e de tecnologia (hardware e/ou software) devidamente seguras
        e atualizadas. Assim, qualquer utilização pelos Usuários de ferramentas
        e tecnologia desatualizadas não consideradas seguras, dar-se-á por conta
        e risco do próprio Usuário, ficando a “Gria” isenta de qualquer
        responsabilidade por danos de qualquer natureza suportados pelos
        Usuários.
      </Typography>
      <Typography className={styles.subtitle}>Dos links:</Typography>
      <Typography>
        A “Gria” não se responsabiliza por informações publicadas por terceiros
        através de sites para os quais este Website contenha um link. Se você
        decidir visitar qualquer outro site, através de um link aqui contido,
        você o fará por sua própria responsabilidade, podendo e devendo adotar
        todas medidas necessárias para se proteger de vírus ou outros elementos
        destrutivos. A existência de links neste Website não implica que a
        “Gria” patrocina ou é associada a qualquer entidade cujos produtos ou
        serviços estejam mencionados no site objeto do link.
      </Typography>
      <Typography className={styles.subtitle}>
        Da vigência, rescisão e modificações destes termos:
      </Typography>
      <Typography>
        Estes Termos permaneceram vigentes por prazo indeterminado, enquanto os
        Usuários fizerem uso deste Website. A “Gria” possui a faculdade em dar
        por terminado, suspender ou interromper unilateralmente, a qualquer
        momento e sem necessidade de prévio aviso, o acesso a este Website, sem
        que qualquer indenização seja devida em razão do término do acesso. A
        “Gria” tem o direito de modificar ou complementar estes Termos, a seu
        exclusivo critério, a qualquer momento, visando sua constante melhoria e
        aprimoramento. As modificações e/ou complementações que versarem sobre:
        a finalidade específica do tratamento de dados dos Usuários obtidos
        através do Website, forma e duração do tratamento, identificação do
        controlador ou informações acerca do uso compartilhado de dados pelo
        controlador e a finalidade serão devidamente destacadas. Para
        esclarecimento, de acordo com o art. 5º, inciso X, da Lei 13.709/18,
        considera-se “tratamento”: “toda operação realizada com dados pessoais,
        com as que referem a coleta, produção, recepção, classificação,
        utilização, acesso, reprodução, transmissão, distribuição,
        processamento, arquivamento, armazenamento, eliminação, avaliação ou
        controle da informação, modificação, comunicação, transferência, difusão
        ou extração”. O uso do Website após modificações e/ou complementações
        implicará na aceitação imediata destes Termos e Condições de Uso
        atualizados. As modificações e/ou complementações destes Termos não
        vigorarão em relação às transações já pactuadas.
      </Typography>
      <Typography className={styles.subtitle}>
        Da lei aplicável e foro:
      </Typography>
      <Typography>
        Estes Termos permaneceram vigentes por prazo indeterminado, enquanto os
        Usuários fizerem uso deste Website. A lei brasileira será aplicável para
        reger e interpretar estes Termos.
      </Typography>
      <Typography className={styles.subtitle}>
        Da aceitação dos termos:
      </Typography>
      <Typography>
        Por meio do “Li e Aceito” e do uso deste Website, os Usuários declaram
        ter lido, compreendido e consentido com as disposições estabelecidas
        nestes Termos. A aceitação destes Termos é absolutamente indispensável à
        utilização dos serviços prestados pela “Gria” por intermédio deste
        Website. Se você não concorda com estes termos e condições, solicitamos
        que não utilize este Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Política de segurança e privacidade:
      </Typography>
      <Typography>
        A Política de Segurança e Privacidade da “Gria” foi elaborada com o
        objetivo de reafirmar nosso compromisso com a segurança e a privacidade
        de informações coletadas dos Usuários que utilizam nossos serviços
        interativos. A presente Política de Privacidade (“Política”) é parte
        integrante dos Termos e Condições de Uso (“Termos”) do Website
        https://www.gria.io A fim de facilitar o entendimento desta Política,
        apresentamos, em resumo, as seguintes definições: <br />
        <b>Dado pessoal: </b>
        informação relacionada a pessoa natural identificada ou identificável.
        <br />
        <b>Dado pessoal sensível:</b> dado pessoal sobre origem racial ou
        étnica, convicção religiosa, opinião política, filiação a sindicato ou a
        organização de caráter religioso, filosófico ou político, dado referente
        à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado
        a uma pessoa natural. <br />
        <b>Banco de dados:</b> conjunto estruturado de dados pessoais,
        estabelecido em um ou em vários locais, em suporte eletrônico ou físico.{' '}
        <br />
        <b>Titular de dados pessoais (Usuário deste website):</b> pessoa natural
        a quem se referem os dados pessoais para utilização deste Website e que
        são objeto de tratamento pela “Gria”. <br />
        <b>Controlador:</b> pessoa natural ou jurídica, de direito público ou
        privado, a quem competem as decisões referentes ao tratamento de dados
        pessoais. <br />
        <b>Operador:</b> pessoa natural ou jurídica, de direito público ou
        privado, que realiza o tratamento de dados pessoais em nome do
        controlador. <br />
        <b>Encarregado:</b> pessoa indicada pelo controlador e operador para
        atuar como canal de comunicação entre o Controlador, os Titulares de
        Dados Pessoais e a Autoridade Nacional de Proteção de Dados (ANPD).{' '}
        <br />
        <b>Agentes de tratamento:</b> o Controlador e o Operador. <br />
        <b>Tratamento:</b> toda operação realizada com dados pessoais, como as
        que se referem a coleta, produção, recepção, classificação, utilização,
        acesso, reprodução, transmissão, distribuição, processamento,
        arquivamento, armazenamento, eliminação, avaliação ou controle da
        informação, modificação, comunicação, transferência, difusão ou
        extração. <br />
        <b>Consentimento:</b> manifestação livre, informada e inequívoca pela
        qual o Titular de Dados Pessoais concorda com o tratamento de seus dados
        pessoais para uma finalidade determinada.
        <br />
        <b>Transferência internacional de dados:</b> transferência de dados
        pessoais para país estrangeiro ou organismo internacional do qual o país
        seja membro. <br />
        <b>Uso compartilhado de dados:</b> comunicação, difusão, transferência
        internacional, interconexão de dados pessoais ou tratamento
        compartilhado de bancos de dados pessoais por órgãos e entidades
        públicos no cumprimento de suas competências legais, ou entre esses e
        entes privados, reciprocamente, com autorização específica, para uma ou
        mais modalidades de tratamento permitidas por esses entes públicos, ou
        entre entes privados. <br />
        <b>Órgão de pesquisa:</b> órgão ou entidade da administração pública
        direta ou indireta ou pessoa jurídica de direito privado sem fins
        lucrativos legalmente constituída sob as leis brasileiras, com sede e
        foro no País, que inclua em sua missão institucional ou em seu objetivo
        social ou estatutário a pesquisa básica ou aplicada de caráter
        histórico, científico, tecnológico ou estatístico. <br />
        <b>Autoridade nacional:</b> órgão da administração pública responsável
        por zelar, implementar e fiscalizar o cumprimento da Lei Geral de
        Proteção de Dados em todo o território nacional. <br />
        <b>Agente de tratamento dos dados:</b> “Gria”. <br />
        <b>Papel da “Gria” no tratamento dos dados:</b> predominantemente
        controladora. <br />
        <b>Tipo de informações pessoais coletadas:</b> a “Gria” coleta, nos
        casos de os Usuários serem Candidatos, nome completo, CPF, data de
        nascimento, gênero, e-mail, telefone fixo e telefone celular, endereço
        completo, bem como dados acerca do cargo Página 10 de 16atualmente
        ocupado, das experiências profissionais, da formação, das certificações,
        de idiomas, de habilidades e demais dados disponibilizados pelo
        Candidato em seu currículo profissional. Nos casos de os Usuários serem
        Empresas Recrutadoras, são coletados a razão social, CNPJ, e-mail,
        telefone fixo e telefone celular, endereço completo, bem como os dados
        acerca da vaga de emprego disponibilizada e do responsável pelo cadastro
        da vaga. Todos os dados coletados são disponibilizados voluntariamente
        pelo próprio Usuário quando preenchido seu cadastro junto ao Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Finalidade do tratamento dos dados:
      </Typography>
      <Typography>
        prestação dos serviços inteligência em Recursos Humanos, com a análise
        dos candidatos e das oportunidades cadastradas, a fim de conectar
        Candidato e Empresas Recrutadoras.
      </Typography>
      <Typography className={styles.subtitle}>Informações pessoais:</Typography>
      <Typography>
        A “Gria” somente coleta dados pessoais fornecidos voluntariamente pelos
        Usuários, sendo solicitados dados que o identifiquem ou ainda que
        permitam que a “Gria” entre em contato com o Usuário. A “Gria” coleta
        informações do Usuário apenas a partir do cadastramento dos Usuários
        junto do Website.
      </Typography>
      <Typography className={styles.subtitle}>Tratamento dos dados:</Typography>
      <Typography>
        O tratamento de dados, nos termos da Lei Geral de Proteção de Dados
        (LGPD), compreende: toda operação realizada com dados pessoais, como as
        que se referem a coleta, produção, recepção, classificação, utilização,
        acesso, reprodução, transmissão, distribuição, processamento,
        arquivamento, armazenamento, eliminação, avaliação ou controle da
        informação, modificação, comunicação, transferência, difusão ou
        extração. O tratamento de dados somente ocorrerá para a finalidade
        destes Termos, permanecendo os dados pessoais dos Usuários deste Website
        mantidos na base de dados da “Gria” de forma segura e adequada, com
        duração indeterminada, a depender do período do tratamento, finalidade
        alcançada ou revogação do consentimento nos termos da LGPD. Considerando
        o quanto necessário para garantia da segurança no tratamento dos dados
        pessoais dos Usuários deste Website, a “Gria” dispõe de software de
        antivírus, firewall e backup em nuvem, de modo a assegurar um nível de
        segurança adequado ao risco. Em caso de violação de dados pessoais, a
        “Gria” notificará a Autoridade Nacional de Proteção de Dados, nos termos
        e condições previstos em lei. Se a violação for capaz de implicar em
        elevado risco para os direitos e liberdades dos Usuários deste Website,
        a “Gria” lhes comunicarão este fato, nos termos e condições legais. As
        informações coletadas podem ser controladas pelos funcionários ou
        prestadores de serviço da “Gria” e transmitidas à órgãos estatais, se
        pertinente, à órgãos de pesquisa, sempre objetivando necessidades
        oriundas da prestação estabelecida entre as partes, ou em caso de
        obrigação legal ou regulatória, em processos judiciais ou
        administrativos, estando cientes os Usuários deste Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Uso de informações pessoais:
      </Typography>
      <Typography>
        A “Gria” utiliza os dados para prestar os serviços de inteligência em
        Recursos Humanos, assim como para retornar ao contato realizado pelo
        Usuário através do canal “Fale Conosco”. A “Gria” também utiliza os
        dados para operar seus negócios, incluindo a análise de desempenho, o
        cumprimento de obrigações legais, o desenvolvimento de força de trabalho
        e a realização de pesquisas. E-mails dos Usuários por eles
        voluntariamente disponibilizados e armazenados nos sistemas da “Gria”
        podem vir a receber notícias, informações e novidades relativos aos
        serviços prestados, entre outros. Se, a qualquer momento, o Usuário
        desejar, poderá cancelar o recebimento de futuros e-mails, seguindo as
        instruções detalhadas em cada e-mail já recebido.
      </Typography>
      <Typography className={styles.subtitle}>
        Motivos pelo quais a ”Gria” compartilha dados pessoais:
      </Typography>
      <Typography>
        A “Gria” compartilha os dados pessoais os Usuários para o fim de prestar
        os serviços de inteligência em Recursos Humanos, assim como para
        concluir solicitações de contato feitas pelo próprio Usuário através do
        Website e para enviar notícias, informações e novidades relativos aos
        serviços prestados. Ainda, a “Gria” pode compartilhar os dados com
        colaboradores autorizados e prestadores de serviços, quando exigido por
        lei ou para responder a um processo jurídico, manter a segurança do
        Website e proteger os direitos ou a propriedade da “Gria”. As
        informações coletadas somente serão compartilhadas quando forem
        necessárias: (i) para prestação adequada dos serviços de inteligência em
        Recursos Humanos; (ii) proteção em caso de conflito; (iii) mediante
        decisão judicial ou requisição de autoridade competente; (iv) com
        empresas provedoras de infraestrutura tecnológica e operacional, como
        empresas intermediadoras de pagamento e provedoras de serviço de
        armazenamento de informações. Em caso de necessidade, a “Gria” poderá
        subcontratar empresas terceirizadas para a realização do tratamento de
        dados pessoais dos Usuários deste Website, sem que ocorra para a
        realização desta atividade de compartilhamento a autorização pelos
        Usuários. Os Usuários deste Website, ao concordarem com esta Política,
        ficam cientes sobre o compartilhamento de seus dados informados neste
        Website, podendo exercer, diretamente junto a “Gria” os direitos
        garantidos pela LGPD, em especial o direito de conhecimento do uso
        compartilhado de dados, a partir do envio de e-mail ao(à) encarregado(a)
        através do endereço suporte@gria.io
      </Typography>
      <Typography className={styles.subtitle}>
        Transferência internacional de dados:
      </Typography>
      <Typography>
        A “Gria” compartilha os dados pessoais os Usuários para o fim de prestar
        os serviços de inteligência em Recursos Humanos, assim como para
        concluir solicitações de contato feitas pelo próprio Usuário através do
        Website e para enviar notícias, informações e novidades relativos aos
        serviços prestados. Ainda, a “Gria” pode compartilhar os dados com
        colaboradores autorizados e prestadores de serviços, quando exigido por
        lei ou para responder a um processo jurídico, manter a segurança do
        Website e proteger os direitos ou a propriedade da “Gria”. Nesses casos,
        os dados são tratados de acordo com a LGPD e demais legislações de
        proteção. A “Gria” tomará as medidas de segurança de acordo com esta
        Política e adotará cláusulas padrão nos contratos com fornecedores e
        prestadores de serviço. Ao navegar neste Website e/ou se comunicar com a
        “Gria”, o Usuário concorda com o tratamento de suas informações,
        inclusive a transferência internacional de dados, quando necessária. A
        “Gria” adotará medidas para garantir que quaisquer informações coletadas
        sejam tratadas com segurança, conforme os padrões de proteção de dados e
        de acordo com esta Política.
      </Typography>
      <Typography className={styles.subtitle}>
        Como a ”Gria” armazena as informações pessoais:
      </Typography>
      <Typography>
        Todos os dados fornecidos pelos Usuários deste Website são recolhidos,
        armazenados, conservados e tratados na plataforma de gerenciamento do
        Website, e são efetuados por colaboradores da “Gria” de acordo com as
        demandas, bem como serão utilizados exclusivamente para prestação dos
        serviços, sendo que, após término, rescisão, resilição ou extinção
        destes Termos, pelo motivo que for, permanecerão armazenados nos
        arquivos da “Gria” da seguinte maneira: a) Dados dissociados de pessoas
        conservar-se-ão sem prazo; b) Dados de contato tratados para fins
        comerciais conservar-se-ão até que o titular retire o seu consentimento;
        e c) Dados dos Usuários conservar-se-ão durante a vigência de seu
        cadastro junto do Website e por mais 10 (dez) anos para os dados com
        relevância fiscal e 20 (vinte) anos para os dados com relevância
        contratual. Em caso de ordem de autoridade legitima ou de pendência de
        processo judicial ou administrativo, os prazos de conservação serão
        estendidos para corresponder aos mesmos. O processamento dos dados será
        interno, ficando a “Gria” autorizada a, caso assim entenda, efetuar esse
        processamento externamente, com operadores subcontratados, de forma que
        deverão seguir todas as normas inerentes ao tratamento de dados pessoais
        estabelecidos pela LGPD, bem como as previsões contratuais firmadas
        entre o Controlador e os referidos Operadores. A “Gria” irá
        comunicar/transferir, no todo ou em parte, os dados pessoais dos
        Usuários deste Website a entidades públicas e/ou privadas, sempre que
        tal comunicação/transferência decorrer de obrigação contratual, legal ou
        que seja necessária para o cumprimento destes Termos ou de outros
        contratos, ficando para tal a “Gria” expressamente autorizada.
      </Typography>
      <Typography className={styles.subtitle}>
        Responsabilidade e confidencialidade do tratamento de dados do usuário
        deste website:
      </Typography>
      <Typography>
        A “Gria” assume o compromisso de realizar o tratamento dos dados
        pessoais dos Usuários deste Website em consonância com as determinações
        da LGPD, bem como quais legislações de privacidade aplicáveis. A “Gria”
        assume o compromisso de manter os dados pessoais do Usuário deste
        Website confidenciais, adotando para tanto todas as medidas técnicas e
        administrativas necessárias. A “Gria” ficará responsável por adimplir
        com, mas não somente, multas administrativas, indenizações, incluindo
        perdas e danos aos Usuários deste Website, titulares de dados pessoais
        afetados, caso descumpra as obrigações assumidas nos presentes Termos ou
        caso terceiros diretamente contratados pela “Gria” descumprirem tais
        obrigações.
      </Typography>
      <Typography className={styles.subtitle}>
        Obrigações da ”Gria” quanto ao tratamento de dados dos usuários:
      </Typography>
      <Typography>
        Para o fiel cumprimento do tratamento dos dados dos Usuários deste
        Website a “Gria” se obriga a a) Seguir estritamente a Lei Geral de
        Proteção de Dados; e b) Realizá-lo através de profissionais que tenham
        boa capacidade técnica, zelo na atividade a ser exercida e respeito,
        ficando ainda responsável, exclusivamente, por qualquer ato ou omissão
        de seus prepostos na consecução do tratamento de dados dos Usuários
        deste Website.
      </Typography>
      <Typography className={styles.subtitle}>Licitude da fonte:</Typography>
      <Typography>
        A “Gria” garante que todas as informações compartilhadas para permitir o
        cumprimento do objeto dos presentes Termos serão coletadas em
        observância à LGPD, garantindo a existência de legítima expectativa dos
        Usuários deste Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Segurança do tratamento de dados:
      </Typography>
      <Typography>
        A “Gria” assume o compromisso de adotar técnicas organizacionais e
        técnicas para garantir a segurança das informações compartilhadas pelos
        Usuários deste Website.
      </Typography>
      <Typography className={styles.subtitle}>
        Direitos do titular de dados:
      </Typography>
      <Typography>
        A partir do início da vigência da LGPD, o Titular de Dados Pessoais terá
        o direito de obter da “Gria”, a qualquer momento, mediante requisição
        formal, informações referentes aos seus dados. A “Gria” terá 15 (quinze)
        dias para responder às solicitações dos Titulares de Dados Pessoais.
        <br />
        Os pedidos serão analisados conforme previsto em legislação vigente e,
        por questões legais, algumas solicitações podem não ser atendidas. Os
        Titulares de Dados Pessoais, conforme os termos da LGPD, podem exercer
        os seus direitos por meio de: <br />
        i) confirmação da existência do tratamento; <br />
        ii) acesso aos dados pessoais tratados; <br />
        iii) correção dos dados pessoais incompletos, inexatos ou
        desatualizados; <br />
        iv) bloqueio ou a eliminação dos dados pessoais; <br />
        v) portabilidade dos dados pessoais;
        <br />
        vi) informação sobre as entidades públicas e privadas com as quais foi
        realizada o compartilhamento de dados; <br />
        vii) comunicação das consequências da revogação do consentimento, e{' '}
        <br />
        viii) comunicação os fatores que levaram a uma decisão automatizada.
      </Typography>
      <Typography className={styles.subtitle}>
        Como exercer os seus direitos:
      </Typography>
      <Typography>
        O Titular de Dados Pessoais Você pode exercer seus direitos entrando em
        contato com o(a) encarregado(a) através do endereço de e-mail
        suporte@gria.io Para mudar suas preferências em relação às notícias,
        informações e novidades relativos aos serviços prestados, os Usuários, a
        qualquer momento, poderão cancelar a assinatura clicando no link enviado
        juntamente com o e-mail.
      </Typography>
      <Typography className={styles.subtitle}>
        Como manter as informações pessoais seguras:
      </Typography>
      <Typography>
        A “Gria” utiliza os melhores protocolos de segurança para preservar a
        privacidade dos dados dos Usuários, mas também recomenda medidas de
        proteção individual. A “Gria” não solicita dados pessoais por telefone,
        WhatsApp, SMS ou e-mail. Dessa forma, em nenhuma hipótese os dados
        pessoais deverão ser fornecidos por tais canais, pois pode ser uma
        tentativa de uso indevido.
      </Typography>
      <Typography className={styles.subtitle}>
        Como entrar em contato com o encarregado da proteção de dados:
      </Typography>
      <Typography>
        O Encarregado da proteção de dados da “Gria” é o responsável para atuar
        como canal de comunicação entre o Controlador, os Titulares de Dados
        Pessoais e a Autoridade Nacional de Proteção de Dados (ANPD), quando ela
        for formalizada. Qualquer dúvida poderá ser encaminhada para o e-mail
        do(a) encarregado(a) através do endereço suporte@gria.io
      </Typography>
      <Typography className={styles.subtitle}>
        Violação de dados pessoais:
      </Typography>
      <Typography>
        Em caso de violação de dados pessoais, a “Gria” notificará a Autoridade
        Nacional de Proteção de Dados, nos termos e condições previstos em lei.
        Se a violação for capaz de implicar em elevado risco para os direitos e
        liberdades dos Usuários, a “Gria” lhes comunicará este fato, nos termos
        e condições legais.
      </Typography>
      <Typography className={styles.subtitle}>
        Vigência do tratamento de dados:
      </Typography>
      <Typography>
        As disposições desta Política serão aplicáveis e permanecerão vigentes
        durante a vigência da relação jurídica entre a “Gria” e Usuários deste
        Website e por mais 10 (dez) anos para os dados com relevância fiscal e
        20 (vinte) anos para os dados com relevância contratual. Em caso de
        ordem de autoridade legitima ou de pendência de processo judicial ou
        administrativo, os prazos de conservação serão estendidos para
        corresponder aos mesmos.
      </Typography>
      <Typography className={styles.subtitle}>
        Mídia incorporada de outros sites:
      </Typography>
      <Typography>
        Os artigos existentes neste site podem incluir conteúdo incorporado
        como, por exemplo, vídeos, imagens, artigos etc. Conteúdos incorporados
        de outros sites se comportam exatamente da mesma forma como se o
        visitante estivesse visitando o outro site. Estes sites podem coletar
        dados dos Usuários, usar cookies, incorporar rastreamento adicional de
        terceiros e monitorar a interação com este conteúdo incorporado,
        incluindo a interação com o conteúdo incorporado se o Usuário tiver
        conta e estiver conectado com o site. A “Gria” informa que o conteúdo
        incorporado de outros websites não são de sua responsabilidade.
      </Typography>
      <Typography className={styles.subtitle}>
        Alteração desta política:
      </Typography>
      <Typography>
        A “Gria” tem o direito de modificar ou complementar esta Política, a
        qualquer momento, a seu exclusivo critério, visando sua constante
        melhoria e aprimoramento.
      </Typography>
      <Typography className={styles.subtitle}>
        Serviços de apoio ao website:
      </Typography>
      <Typography>
        Empresas contratadas para fornecer eventuais serviços de apoio ao
        Website da “Gria” deverão seguir rigorosamente esta Política.
      </Typography>
      <Box className={styles.checkbox}>
        <Checkbox className={styles.input} onChange={handleChange} />
        <Typography>Concordo com os termos de uso</Typography>
      </Box>
      <Button
        onClick={sendTermsVersion}
        variant="contained"
        disabled={!checked}
        className={styles.button}
      >
        Continuar
      </Button>
    </Page>
  );
}

export default Terms;
